import PropTypes from 'prop-types'

const unknownWordCorrectionPropType = PropTypes.shape({
  value: PropTypes.number,
  type: PropTypes.number,
  ingredientKeywordMatchType: PropTypes.number,
  languageId: PropTypes.number,
  allergenId: PropTypes.number,
  dietId: PropTypes.number,
  ingredientId: PropTypes.number,
})

export default unknownWordCorrectionPropType
